
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import TtkList from './TtkList';
const InvitationTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price Percard(printed) :</b>&nbsp;<span>&#8377;{data?.PiecePrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Unboxed Invites :</b>&nbsp;<span>{data?.invites}</span></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Boxed Invites :</b>&nbsp;<span>{data?.boxed}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Cities :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Minimum Order Quanitiy :</b>&nbsp;<span>{data?.order}</span></p>
                        </div>
                    </div>

                    <div className='row mb-1'>

                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Card Specialty :</b>&nbsp;<TtkList data={data?.cardSpecialty} /></p>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default InvitationTTK